/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp4 } from './commonProp4';

export const home_appliances : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["TV_HOME_CINEMA", "TV, p\u0159ehr\u00e1va\u010de a dom\u00e1c\u00ed kina"],
        ["AUDIO_HIFI", "R\u00e1dia, audio a HiFi"],
        ["ANTENNA_SATELLITE_SETTOP_BOX", "Ant\u00e9na, satelit, set-top box"],
        ["WASHERS_DRYERS", "Pra\u010dky a su\u0161i\u010dky"],
        ["OVENS_COOKERS_HOBS", "Spor\u00e1ky, trouby a varn\u00e9 desky"],
        ["MICROWAVE_OVENS", "Mikrovlnky"],
        ["FRIDGES_FREEZERS", "Ledni\u010dky a mraz\u00e1ky"],
        ["COOKER_HOODS", "Digesto\u0159e"],
        ["DISHWASHERS", "My\u010dka n\u00e1dob\u00ed"],
        ["FRYERS", "Frit\u00e9zy"],
        ["STEAMERS_RICE_COOKERS", "Elektrick\u00e9 hrnce, p\u00e1nve a r\u00fd\u017eovary"],
        ["TOASTERS_SANDWICH_MAKERS", "Topinkova\u010de, toastova\u010de, vaflova\u010de"],
        ["COFEE_MACHINES_KETTLES", "K\u00e1vovary, rychlovarn\u00e9 konvice"],
        ["FOOD_MIXERS", "Mix\u00e9ry, od\u0161\u0165av\u0148ova\u010de a kuchy\u0148sk\u00e9 roboty"],
        ["BREADMAKERS", "Pek\u00e1rny na chl\u00e9b"],
        ["SODA_MAKERS", "V\u00fdrobn\u00edky sody"],
        ["WATER_FILTERS", "Filtra\u010dn\u00ed konvice"],
        ["GRILLS", "Elektrick\u00e9 grily (ne zahradn\u00ed)"],
        ["VACUUM_STEAM_CLEANERS", "Vysava\u010de, tepova\u010de a parn\u00ed \u010disti\u010de"],
        ["IRONS", "\u017dehli\u010dky"],
        ["AIRCONDITIONERS", "Klimatizace"],
        ["ICE_CREAM_MAKERS_YOGURT_MAKERS", "Zmrzlinova\u010de, jogurtova\u010de"],
        ["BOILER_RADIATOR", "Bojler, radi\u00e1tor"],
        ["BIO_ELECTRIC_FIREPLACE", "Biokrb, elektrick\u00fd krb"],
        ["OTHER_HOME_APPLIANCES", "Jin\u00e9"],
    ],
    p_brand: [
        d("AEG"),
        d("Amica"),
        d("Ariston"),
        d("Baumatic"),
        d("Beko"),
        d("BOSCH"),
        d("Braun"),
        d("Brita"),
        d("Electrolux"),
        d("ETA"),
        d("Fagor"),
        d("Gorenje"),
        d("Grundig"),
        d("Hyundai"),
        d("Ikea"),
        d("Indesit"),
        d("K\u00e4rcher"),
        d("Krups"),
        d("LG"),
        d("Mora"),
        d("Moulinex"),
        d("Orava"),
        d("Panasonic"),
        d("Philips"),
        d("Rowenta"),
        d("Samsung"),
        d("Sencor"),
        d("Siemens"),
        d("Silver Crest"),
        d("Sodastream"),
        d("Sony"),
        d("Tefal"),
        d("Whirlpool"),
        d("Zanussi"),
        d("Zelmer"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "Jin\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
